import { FC, useState } from 'react';
import { Modal } from '../../../../components/modal/modal';
import FontBody1 from '../../../../components/fonts/font-body1/font-body1';
import FontHeading3 from '../../../../components/fonts/font-heading3/font-heading3';
import { FONT_COLOR, FONT_VARIANT } from '../../../../components/fonts/font-props';
import { Button } from '../../../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../../../components/inputs/button-variants';
import Icon from '../../../../components/icons/icon/icon';
import IconCheck from '../../../../components/icons/icon-check/icon-check';
import IconExchange from '../../../../components/icons/icon-exchange/icon-exchange';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';
import planApprovalIllustration from '../../../../images/plan-approval.svg';
import PlanApprovalRedirectOverlay from './plan-approval-redirect-overlay';
import Divider from '../../../subscription-plans/components/plan-info/divider/divider';
import './plan-approval-modal.scss';

const TRANSLATION_SCOPE = 'dashboard-home';

interface IPlanApprovalModalProps {
    approvalUrl: string;
}

const PlanApprovalModal: FC<IPlanApprovalModalProps> = ({ approvalUrl }) => {
    const { getTranslation } = useDashboardTranslation();
    const [isRedirecting, setIsRedirecting] = useState(false);

    const handleContinue = () => {
        setIsRedirecting(true);
        (window.top ?? window).location.href = approvalUrl;
    };

    const bullets = [
        getTranslation('PLAN_APPROVAL_BULLET_APPROVE_IN_SHOPIFY', TRANSLATION_SCOPE),
        getTranslation('PLAN_APPROVAL_BULLET_TAKES_UNDER_A_MINUTE', TRANSLATION_SCOPE),
    ];

    return (
        <>
            <Modal onCloseClicked={() => {}}>
                <div
                    className="plan-approval-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="plan-approval-modal-title"
                    tabIndex={-1}
                >
                    <div className="plan-approval-modal__content">
                        <img
                            className="plan-approval-modal__illustration"
                            src={planApprovalIllustration}
                            alt=""
                        />
                        <div id="plan-approval-modal-title">
                            <FontHeading3
                                color={FONT_COLOR.NEUTRAL11_MENU}
                                variant={[FONT_VARIANT.BOLD]}
                            >
                                {getTranslation('PLAN_APPROVAL_TITLE', TRANSLATION_SCOPE)}
                            </FontHeading3>
                        </div>
                        <FontBody1 color={FONT_COLOR.SEMANTIC_3}>
                            {getTranslation('PLAN_APPROVAL_DESCRIPTION', TRANSLATION_SCOPE)}
                        </FontBody1>
                        <ul className="plan-approval-modal__bullets">
                            {bullets.map((bullet) => (
                                <li key={bullet} className="plan-approval-modal__bullet">
                                    <Icon Component={IconCheck} color="var(--color-semantic-1)" />
                                    <FontBody1 color={FONT_COLOR.NEUTRAL10}>{bullet}</FontBody1>
                                </li>
                            ))}
                        </ul>
                        <div className="plan-approval-modal__redirect-hint">
                            <Icon Component={IconExchange} color="var(--color-accent-1)" />
                            <FontBody1 color={FONT_COLOR.NEUTRAL10}>
                                {getTranslation('PLAN_APPROVAL_REDIRECT_HINT', TRANSLATION_SCOPE)}
                            </FontBody1>
                        </div>
                        <Divider />
                        <div className="plan-approval-modal__actions">
                            <Button
                                text={getTranslation('PLAN_APPROVAL_CONTINUE_TO_SHOPIFY', TRANSLATION_SCOPE)}
                                variant={BUTTON_VARIANTS.Primary}
                                onClick={handleContinue}
                                disabled={isRedirecting}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
            {isRedirecting && <PlanApprovalRedirectOverlay />}
        </>
    );
};

export default PlanApprovalModal;
